module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAeUlEQVR42u3awQkAIAwEQZu2KVuymFPwZQ03gS3AeQXiSDKaq348AAAAAAAAAAAAAAC3uXaaAgAAAAAAAAAAAAAAAAAAAF5t8wPcSVMAAAAAAAAAAIuQVRgAAAAAAAAAAAAAAAAAAJQfRvwUBQAAAAAAAAAAAACgpwOLDXG98JX0rwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Botswana.png
// module id = /sAW
// module chunks = 0 62 63